import { Button, Typography, Box } from "@mui/material";
import { GridOverlay } from '@mui/x-data-grid';

export function TableRetryButton({ message, retry }: { message?: string; retry: () => void }) {
    return () => {
        return (
            <GridOverlay>
                <Box
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'auto',
                        height: '100%',
                        minHeight: '2em',
                        padding: '1.2em 0'
                    }}
                >
                    <Typography variant="body1" color="text.secondary">
                        {message || 'No rows'}
                    </Typography>
                    {
                        retry ? (
                            <Button
                                variant="outlined"
                                onClick={() => retry()}
                                style={{
                                    margin: '0 0.8em'
                                }}
                            >Retry</Button>
                        ) : null
                    }
                </Box>
            </GridOverlay>
        );
    }
}